<!--
 * @Author: vince
 * @Date: 2021-08-23 19:38:05
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2022-01-08 13:40:09
 * @Description: 
-->
<template>
  <div class="tpl-link">
    <div class="link-tit">
      <h5>{{ linkInfo.topic }}</h5>
      <h4>
        <i :class="mapLinkIcon(linkInfo.nodeType)"></i>
        {{ linkInfo.nodeTypeDesc }}
      </h4>
    </div>
    <div class="link-content">
      <div  class="link-desc">
        <span>{{ linkInfo.remark }}</span>
        <upload-link
          v-if="isAdmin"
          ref="upRes"
          :showFileList="false"
          accept="*"
          :fileLimit="10"
          @changeUpload="(fileList) => successUpload(fileList)"
        >
          <template slot="body">
            <el-button type="primary" size="small">上传</el-button>
          </template>
        </upload-link>
      </div>

      <LinkFile
        :isShowDelete="true"
        :link-info="linkInfo"
        :getLinkInfo="getLinkInfo"
        :isAdmin="isAdmin"
      ></LinkFile>
    </div>
  </div>
</template>
<script>
import { mapLinkIcon } from "@/utils/index.js";
import LinkFile from "../components/link/LinkFile.vue";
import UploadLink from "@/components/upload/UploadLink.vue";
import { mapState } from "vuex";
import { postJson } from "@/http/fetch.js";
export default {
  props: {
    linkInfo: {
      type: Object,
    },
    getLinkInfo: {
      type: Function,
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    isAdmin() {
      return (
        this.userInfo.roleCodes.includes("admin") ||
        this.linkInfo.isSpeaker == 1 ||
        this.linkInfo.isCreateBy == 1
      );
    },
  },
  data() {
    return {};
  },
  methods: {
    mapLinkIcon,
    getInfo() {
      this.getLinkInfo(this.$route.query.nodeCode);
    },
    async successUpload(fileList) {
      let obj = {};
      try {
        obj.actCode = sessionStorage.getItem("actCode");
        obj.operatorId = this.userInfo.userId;
        obj.attachSize = fileList[0].attachSize;
        obj.attachName = fileList[0].attachName;
        obj.attachType = fileList[0].attachType;
        obj.attachUrl = fileList[0].attachUrl;
        obj.nodeCode = this.$route.query.nodeCode;
        await postJson("node/saveNodeAttachInfo", obj);
        this.$refs.upRes.clearFiles();
        this.getInfo();
      } catch (err) {
        console.log("err", err);
      }
    },
  },
  components: { LinkFile, UploadLink },
};
</script>
<style lang="less" scoped>
.tpl-link {
  background: #fff;
  .link-tit {
    border-bottom: 2px solid #eee;
    padding: 8px 15px;
    h5 {
      font-size: 14px;
      margin-bottom: 4px;
      font-weight: 700;
    }
    h4 {
      font-size: 13px;
      color: @hui;
      i {
        font-size: 14px;
        color: @color;
      }
    }
  }
  .link-desc {
    display: flex;
    justify-content: space-between;
    span {
      font-weight: 700;
      padding: 15px;
      font-size: 14px;
    }
  }
  .link-content {
    padding: 10px 25px;
    background-color: #fff;
    ul {
      padding: 0 !important;
    }
  }
}
</style>